import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { OrderedMap, Map } from 'immutable';
import { FormattedMessage } from 'react-intl';

import User from 'models/user';

import LicensePlateField from 'components/account/saved-vehicles/vehicle-form/license-plate-field';
import DefaultVehicleCheckbox from 'components/vehicles/modal/license-plate/default-vehicle-checkbox';
import SelectVehicle from 'components/vehicles/modal/license-plate/select-vehicle';
import AddVehicleLabel from 'components/vehicles/modal/license-plate/add-vehicle-label';

import withErrors from 'containers/form-validation/error-wrapper';

const propTypes = {
  user: PropTypes.instanceOf(User).isRequired,
  vehicles: PropTypes.instanceOf(OrderedMap),
  errors: PropTypes.instanceOf(Map),
  submitForm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
};

const defaultProps = {
  vehicles: OrderedMap(),
  errors: Map(),
};
export class LicensePlateModal extends Component {
  constructor(props) {
    super(props);

    this.handleModalClose = this.handleModalClose.bind(this);
    this.onCheckboxClick = this.onCheckboxClick.bind(this);
    this.onDropdownSelect = this.onDropdownSelect.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.submitVehicleForm = this.submitVehicleForm.bind(this);

    this.state = {
      show: true,
      vehicleId: null,
      plateNumber: null,
      isDefault: false,
    };
  }

  componentWillMount() {
    const { vehicles } = this.props;
    if (vehicles.size) {
      let defaultId;
      let defaultPresent = false;
      for (const vehicle of vehicles.toArray()) {
        if (vehicle.isDefault) {
          defaultId = vehicle.id;
          defaultPresent = vehicle.id;
          break;
        }

        if (!defaultId) {
          defaultId = vehicle.id;
        }
      }

      this.setState({
        vehicleId: defaultId,
        isDefault: defaultPresent,
      });
    }
  }

  handleModalClose() {
    const { onClose } = this.props;
    this.setState({
      show: false,
    });
    if (onClose) {
      onClose();
    }
  }

  onTextChange(plateNumber) {
    this.setState({ plateNumber });
  }

  onCheckboxClick() {
    this.setState({
      isDefault: !this.state.isDefault,
    });
  }

  onDropdownSelect(vehicleId) {
    this.setState({
      vehicleId,
    });
  }

  submitVehicleForm() {
    const { setErrors } = this.props;
    const { plateNumber, vehicleId, isDefault } = this.state;
    const error = this.licensePlateField.getValidationError();
    if (plateNumber && error) {
      setErrors(error);
    } else {
      this.props.submitForm({
        vehicleId: !plateNumber ? vehicleId : null,
        plateNumber: plateNumber || null,
        isDefault,
      });
    }
  }

  render() {
    const { errors, dismissError, vehicles } = this.props;
    return (
      <div className="panel-body">
        <Modal className="license-plate-modal" show={this.state.show} onHide={this.handleModalClose}>
          <h4 className="h4 align-center">
            <FormattedMessage
              id="parking-pass.plate-modal-prompt"
              defaultMessage="HOLD UP! WE NEED YOUR LICENSE PLATE."
            />
          </h4>
          <p>
            <FormattedMessage
              id="parking-pass.plate-modal-explanation"
              defaultMessage="This location validates your parking with your vehicle&apos;s license plate. To avoid being towed, enter a license plate before you park."
            />
          </p>
          <SelectVehicle
            vehicles={vehicles}
            vehicleId={this.state.vehicleId}
            onDropdownSelect={this.onDropdownSelect}
          />
          <div className="license-plate-section license-plate-section-bottom" >
            <div className="license-plate-title"><AddVehicleLabel vehicles={vehicles} /></div>
            <LicensePlateField
              ref={(input) => { this.licensePlateField = input; }}
              placeholder="Enter License Plate"
              isSimpleInput
              additionalClassNames={['license-plate-modal-input']}
              value={this.state.plateNumber || ''}
              onChange={this.onTextChange}
              errors={errors}
              dismissError={dismissError}
            />
            <DefaultVehicleCheckbox
              isDefault={this.state.isDefault}
              onCheckboxClick={this.onCheckboxClick}
              user={this.props.user}
            />
            <p className="hidden-xs">
              <FormattedMessage
                id="parking-pass.plate-modal-notice"
                defaultMessage="No worries. This information is not used for any purpose other than to verify your booking. If the info you provide does not match your vehicle, you may be towed."
              />
            </p>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <a className="btn btn-block btn-primary" onClick={this.submitVehicleForm}>
                <FormattedMessage
                  id="parking-pass.save-vehicle"
                  defaultMessage="SAVE VEHICLE"
                />
              </a>
            </div>
            <div className="col-sm-6 align-center do-this-later">
              <a onClick={this.handleModalClose}>
                <FormattedMessage
                  id="parking-pass.do-later"
                  defaultMessage="I'LL DO THIS LATER"
                />
              </a>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

LicensePlateModal.propTypes = propTypes;
LicensePlateModal.defaultProps = defaultProps;
export default withErrors(LicensePlateModal);
